<template>
  <div>
    <v-app-bar :dark="false" :elevation="0" app class="backofficeAppBar hiddePrintElement">
      <v-app-bar-nav-icon color="white" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-img
          :lazy-src="logo"
          :src="logo"
          alt="BACKOFFICE"
          class="cursor-pointer-action mx-0 mx-md-16"
          max-width="50"
          style="background: white; border-radius: 50%"
          @click="$router.push('/dashboard')"
      />
      <v-spacer/>
      <div class="d-none d-md-flex display-align-center mr-2">
        <div>
        <span class="login-user-text"
        >{{ getDayTime }}, {{ getUser.name || "" }}</span
        >
        </div>
        <div class="ml-4">
          <v-avatar size="40">
            <img
                :alt="getUser.name"
                src="https://w7.pngwing.com/pngs/81/570/png-transparent-profile-logo-computer-icons-user-user-blue-heroes-logo-thumbnail.png"
            />
          </v-avatar>
        </div>
      </div>
      <v-menu :min-width="140" transition="scroll-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="getStores && getStores?.length" class="hiddePrintElement" dark text v-bind="attrs" v-on="on">
            {{storeName}}
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
              v-for="item in getStores"
              :key="item.title"
              link
              @click="handleClickSelectedStore(item)"
              :class="{'selected-store': selectedStore === item.uuid}"
          >

            <v-list-item-content>
              <v-list-item-title class="menu-title"
              >{{ item.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu :min-width="140" transition="scroll-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="hiddePrintElement" dark icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense class="d-none d-md-block">
          <v-list-item
              v-for="item in menu"
              :key="item.title"
              link
              @click="handleClickMenu(item)"
          >
            <v-list-item-content>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-content>

            <v-list-item-content>
              <v-list-item-title class="menu-title"
              >{{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list dense class="d-block d-md-none">
          <v-list-item
              v-for="item in menuResponsive"
              :key="item.title"
              link
              @click="handleClickMenu(item)"
          >
            <div class="d-flex flex-column my-2">
              <v-icon>{{ item.icon }}</v-icon>
              <v-spacer/>
              <v-list-item-title class="menu-title ml-2">
                {{ item.title }}
              </v-list-item-title>
            </div>
          </v-list-item>
        </v-list>
      </v-menu>
      <!--    <div v-for="item in items" :key="item.title" class="d-none d-md-block">
            <v-btn
                v-if="enableRoute(item)"
                class="btn-link"
                dark
                text
                @click="navigate(item.path)"
            >
              {{ item.title }}
            </v-btn>
          </div>
          <v-spacer/>
          <div class="d-none d-md-flex display-align-center mr-2">
            <div>
              <span class="login-user-text"
              >{{ getDayTime }}, {{ getUser.name || "" }}</span
              >
            </div>
            <div class="ml-4">
              <v-avatar size="40">
                <img
                    :alt="getUser.name"
                    src="https://w7.pngwing.com/pngs/81/570/png-transparent-profile-logo-computer-icons-user-user-blue-heroes-logo-thumbnail.png"
                />
              </v-avatar>
            </div>
          </div>
          <v-btn class="hiddePrintElement" dark icon @click="toggleTheme">
            <v-icon>mdi-brightness-4</v-icon>
          </v-btn>
          <v-menu :min-width="140" transition="scroll-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="hiddePrintElement" dark icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense class="d-none d-md-block">
              <v-list-item
                  v-for="item in menu"
                  :key="item.title"
                  link
                  @click="handleClickMenu(item)"
              >
                <v-list-item-content>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-content>

                <v-list-item-content>
                  <v-list-item-title class="menu-title"
                  >{{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list dense class="d-block d-md-none">
              <v-list-item
                  v-for="item in menuResponsive"
                  :key="item.title"
                  link
                  @click="handleClickMenu(item)"
              >
                <div class="d-flex flex-column my-2">
                  <v-icon>{{ item.icon }}</v-icon>
                  <v-spacer/>
                  <v-list-item-title class="menu-title ml-2">
                    {{ item.title }}
                  </v-list-item-title>
                </div>
              </v-list-item>
            </v-list>
          </v-menu>-->
    </v-app-bar>
    <v-navigation-drawer
        v-model="drawer"
        temporary
        sticky
        fixed
    >
      <v-list
          nav
          dense
      >
        <v-list-item class="px-2">
          <v-list-item-icon>
            <v-icon size="30">mdi-account-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ getUser.name || 'N/A' }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ getUser.email || 'N/A' }}</v-list-item-subtitle>

            <v-list-item-subtitle v-if="getUser && getUser.roles.length">
              <div v-for="(role, index) in getUser.roles" :key="index">
                <span style="font-size: 10px; color: var(--v-textCalendar-base); font-weight: bold">{{ role }}</span>
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <div>
          <v-list-item-group>
            <div v-for="(itemMenu, index) in items" :key="index">
              <v-list-group v-if="itemMenu.children && itemMenu.children.length && showByRolChildren(itemMenu)" :value="false">
                <template #activator>
                  <v-list-item class="remove-padding-list">
                    <v-list-item-icon>
                      <v-icon>{{ itemMenu.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ itemMenu.title }}</v-list-item-title>
                  </v-list-item>
                </template>
                <div v-for="(child, childIndex) in itemMenu.children" :key="childIndex">
                  <v-list-item v-if="showByRol(child)" style="padding-left: 10%"
                               @click="handleClickMenu(child)">
                    <v-list-item-icon>
                      <v-icon>{{ child.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ child.title }}</v-list-item-title>
                  </v-list-item>
                </div>
              </v-list-group>

              <div v-else>
                <v-list-item  v-if="showByRol(itemMenu)" @click="handleClickMenu(itemMenu)">
                  <v-list-item-icon>
                    <v-icon>{{ itemMenu.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ itemMenu.title }}</v-list-item-title>
                </v-list-item>
              </div>
            </div>
          </v-list-item-group>
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>

</template>

<script>
import Logo from "../assets/images/arrow.png";
import router from "../router";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  name: "AppBar",
  data() {
    return {
      selectedStore: '',
      drawer: false,
      logo: Logo,
      items: [
        {title: "Calculadora", icon: "mdi-badge-account", path: "/dashboard", children:[]},
        {title: "Usuarios", icon: "mdi-badge-account", path: "/employees", children:[]},
        {title: "Tipo de series", icon: "mdi-car-cog", path: "/series-types", children:[]},
        {title: "Gestión de ordenes", icon: "mdi-order-bool-descending-variant", path: "/orders", children:[]},
        {title: "Reposiciones", icon: "mdi-repeat", path: "/reposition-orders", children:[]}
      ],
      menu: [{title: "Cerrar sesión", icon: "mdi-logout", path: "/"}],
      menuResponsive: [
        {title: "Cerrar sesión", icon: "mdi-logout", path: "/"}
      ],
    };
  },
  computed: {
    getDayTime() {
      const hour = moment().hour();
      if (hour >= 6 && hour < 12) {
        return "Buenos días";
      } else if (hour >= 12 && hour < 20) {
        return "Buenas tardes";
      } else {
        return "Buenas noches";
      }
    },
    storeName() {
      const store = this.getStores?.find((item)=>item.uuid === this.selectedStore)
      return store?.name || 'Selecciona un estado'
    },
    ...mapGetters("auth", ["getResources", "getUser", "getStores"])
  },
  created(){
   const selectedStorageStore = localStorage.getItem('selectedStore')
    if (selectedStorageStore) {
      this.selectedStore = selectedStorageStore
    }
  },
  methods: {
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    logout() {
      this.$store.commit("auth/CLEAR_TOKEN");
      router.replace({path: "/"});
    },
    handleClickMenu(item) {
      switch (item.path) {
        case "/":
          this.logout();
          break;
        default:
          router.push(item.path);
          break;
      }
    },
    showByRol(item) {
      return this.getResources.find((itemResource) => itemResource.resourceName === item.path)
    },
    showByRolChildren(item) {
      const hasAccess = this.getResources.find(
          (itemResource) => itemResource.resourceName === item.path
      );

      if (hasAccess) {
        return true;
      }

      if (item.children && item.children.length) {
        return item.children.some((child) => this.showByRol(child));
      }

      // Si no tiene acceso ni él ni sus hijos
      return false;
    },
    handleClickSelectedStore(item){
      localStorage.setItem('selectedStore', item?.uuid)
      this.selectedStore = item?.uuid
      location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.backofficeAppBar {
  display: flex;
  flex-direction: column;
  background: linear-gradient(
          var(--v-appBarInitial-base) 19%,
          var(--v-appBarInitial-base) 88%
  );
}

.btn-link {
  font-family: "Montserrat-Light";
  text-transform: none;
}

.menu-title {
  font-family: "Montserrat-Medium";
}

.login-user-text {
  font-size: 16px;
  font-family: "Montserrat-Regular";
  color: var(--v-whiteText-base);
}

.circle > div {
  border: 2px solid var(--v-avatarBorder-base);
}


@media print {
  .hiddePrintElement {
    display: none;
  }
}

.remove-padding-list {
  padding-left: 0 !important;
}

.v-navigation-drawer {
  width: fit-content !important;
}

.selected-store {
  background-color: #f0f0f0 !important;
}
</style>
